import * as React from 'react'
import { SVGProps } from 'react'

const MANAUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16.0005' cy='15.9997' r='15.9996' fill='white' />
    <path d='M13.1484 12.2148V21.9923H21.2963L13.1484 12.2148Z' fill='url(#paint0_linear_4956_76313)' />
    <path d='M5 21.9923H13.1479V12.2148L5 21.9923Z' fill='url(#paint1_linear_4956_76313)' />
    <path d='M21.4004 17.4292V24.5993H27.3777L21.4004 17.4292Z' fill='url(#paint2_linear_4956_76313)' />
    <path d='M15.4287 24.5993H21.3995V17.4292L15.4287 24.5993Z' fill='url(#paint3_linear_4956_76313)' />
    <circle cx='21.3998' cy='12.2145' r='3.25915' fill='#FFC95B' />
    <circle cx='13.1472' cy='8.62957' r='1.62957' fill='#FFC95B' />
    <defs>
      <linearGradient
        id='paint0_linear_4956_76313'
        x1='13.1457'
        y1='12.2148'
        x2='13.1457'
        y2='21.9923'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#A524B3' />
        <stop offset='1' stopColor='#FF2D55' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_4956_76313'
        x1='9.07393'
        y1='10.1899'
        x2='2.27364'
        y2='15.8568'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#FF2D55' />
        <stop offset='1' stopColor='#FFBC5B' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_4956_76313'
        x1='21.3984'
        y1='17.4292'
        x2='21.3984'
        y2='24.5993'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#A524B3' />
        <stop offset='1' stopColor='#FF2D55' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_4956_76313'
        x1='18.4141'
        y1='15.9443'
        x2='13.4279'
        y2='20.0964'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#FF2D55' />
        <stop offset='1' stopColor='#FFBC5B' />
      </linearGradient>
    </defs>
  </svg>
)

export default MANAUSD
